module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "tiny",
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('h4', [_vm._v("是否需要上门服务？")]), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.IT_Service),
      callback: function($$v) {
        _vm.$set(_vm.form, "IT_Service", $$v)
      },
      expression: "form.IT_Service"
    }
  }, [_vm._v("需要")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.IT_Service),
      callback: function($$v) {
        _vm.$set(_vm.form, "IT_Service", $$v)
      },
      expression: "form.IT_Service"
    }
  }, [_vm._v("不需要")])], 1)]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.IT_Service == 1),
      expression: "form.IT_Service==1"
    }],
    attrs: {
      "label": "服务金额",
      "label-width": "70px"
    }
  }, [_c('el-input', {
    staticClass: "formLength",
    model: {
      value: (_vm.form.IT_ServiceMoney),
      callback: function($$v) {
        _vm.$set(_vm.form, "IT_ServiceMoney", $$v)
      },
      expression: "form.IT_ServiceMoney"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择网络监测人员"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.form.CheckUserId),
      callback: function($$v) {
        _vm.$set(_vm.form, "CheckUserId", $$v)
      },
      expression: "form.CheckUserId"
    }
  }, _vm._l((_vm.ModuleEmployee), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.EmployeeName
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-735bd599!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Network/networkCheck/components/completeDialog/index.vue
// module id = 1524
// module chunks = 1